import React from 'react';
import { bonuses } from '../data/content';
import { BonusCover } from './BonusCover';
import { SectionHeading } from './SectionHeading';

// 3 + 2 centered layout on desktop
const placement = ['', '', '', 'lg:col-start-2', ''];
export function Bonuses() {
  return <section aria-labelledby="bonuses-title" className="bg-cream" data-id="element-22" data-mp="at8uo6i86ra9">
      <div className="mx-auto max-w-content px-5 py-20 sm:px-8 lg:py-28" data-id="element-23" data-mp="fslgqp19vubs">
        <SectionHeading id="bonuses-title" title={<>
              You’ll Also Get <span className="italic text-coral" data-id="element-25" data-mp="5x1l83qmexnk">5 Free Bonuses</span>
            </>} intro="Not just printables — a complete Gospel-sharing system: what to say, how to pray, how to invite, what to share, and a plan to make it a habit." data-id="element-24" data-mp="1u58uurobxs2" />
        <ol className="mx-auto mt-16 grid max-w-5xl grid-cols-1 gap-x-8 gap-y-14 sm:grid-cols-2 lg:grid-cols-6" data-id="element-26" data-mp="1mai2fvrzruvq">
          {bonuses.map((b, i) => <li key={b.number} className={`flex flex-col lg:col-span-2 ${placement[i]}`} data-id="element-27" data-mp="1r8td28q429f0" data-mpi={i}>
              <div className="relative mx-auto w-full max-w-[280px]" data-id="element-28" data-mp="3id53d2x9ix97">
                <span className="absolute -left-3 -top-3 z-10 rounded-full bg-navy px-3 py-1.5 text-xs font-extrabold uppercase tracking-[0.1em] text-white shadow-card" data-id="element-29" data-mp="3dfv4kwnzh98p">
                  Bonus {b.number}
                </span>
                <BonusCover bonus={b} data-id="element-30" data-mp="3n6g5wrv1krvb" />
              </div>
              <div className="mx-auto mt-6 flex max-w-[300px] flex-1 flex-col text-center" data-id="element-31" data-mp="2zfaquewxe3m2">
                <h3 className="font-display text-2xl leading-tight text-navy" data-id="element-32" data-mp="2ugqzfyzkbzmb">{b.name}</h3>
                <p className="mt-2 font-bold text-coral-deep" data-id="element-33" data-mp="38g8vmzf6uf5p">{b.keyIdea}</p>
                <p className="mt-2 text-[15px] leading-relaxed text-ink-soft" data-id="element-34" data-mp="38e5t5fwumtk3">{b.description}</p>
                <p className="mt-auto pt-4 text-xs font-extrabold uppercase tracking-[0.14em] text-leaf-deep" data-id="element-35" data-mp="33ja1igviy87i">Included free</p>
              </div>
            </li>)}
        </ol>
      </div>
    </section>;
}